import React from 'react';
import { useState, useEffect } from 'react';
import { AppBar, Box, Button, Container, Link, Grid, Paper, IconButton, Typography } from '@mui/material';

import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
//import TableCell from '@mui/material/TableCell';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
//import Paper from '@mui/material/Paper';


const ActivityClass = () => {
  return (
    <>
      <div>

        <Box height={80} />

        <Grid container spacing={0} alignItems="center" justify="center">
              <Grid item xs={2} />
              <Grid item xs={8}>
                  <Card>
                  <CardHeader title='课外活动课主页面'/>
                  <CardContent>
                    <Box textAlign={'center'}>
                      <Typography>
                        课外活动与兴趣小组旨在为学生提供一个丰富多彩的学习环境，促进他们在学术之外的发展。这些活动涵盖广泛的领域，包括体育、艺术、音乐、戏剧、科学俱乐部、文学社团等，旨在培养学生的兴趣爱好、团队合作精神和领导能力。通过参与课外活动，学生不仅能够增强自信心和社交技能，还能发现和发展自己的潜力，为未来的学习和生活打下坚实的基础。
                      </Typography>
                    </Box>
                  </CardContent>
                  </Card>

              </Grid> 

              <Grid item xs={2} />
        </Grid>


        <Grid container spacing={0} alignItems="center" justify="center">
              <Grid item xs={2} />
              {/* <Grid item xs={8}>
                  <Card>
                  <CardHeader title='课外活动课主页面'/>
                  <CardContent>
                    <Box textAlign={'center'}>
                      <Typography>
                        课外活动与兴趣小组旨在为学生提供一个丰富多彩的学习环境，促进他们在学术之外的发展。这些活动涵盖广泛的领域，包括体育、艺术、音乐、戏剧、科学俱乐部、文学社团等，旨在培养学生的兴趣爱好、团队合作精神和领导能力。通过参与课外活动，学生不仅能够增强自信心和社交技能，还能发现和发展自己的潜力，为未来的学习和生活打下坚实的基础。
                      </Typography>
                    </Box>
                  </CardContent>
                  </Card>

              </Grid>  */}

              <Grid item xs={8}>
                  <Card>
                  <CardHeader title='2026-2027 课外活动课目录'/>
                  <CardContent>
                    <Box textAlign={'center'}>
                      <TableContainer component={Paper}>
                        <Table 
                          sx={{
                            [`& .${tableCellClasses.root}`]: {
                              borderRight: '1px solid rgba(224, 224, 224, 1)', // Adds vertical lines
                            },
                            [`& .${tableCellClasses.root}:last-child`]: {
                              borderRight: 'none', // Prevents border on the very right edge
                            },
                          }}
                        >
                          <TableHead>
                            <TableRow>
                              <TableCell sx={{background: 'lightgray',fontWeight: 'bold'}}>Class<br />课程</TableCell>
                              <TableCell sx={{background: 'lightgray',fontWeight: 'bold'}}>Syllabus<br />大纲</TableCell>
                              <TableCell sx={{background: 'lightgray',fontWeight: 'bold'}}>Teacher<br />教师</TableCell>
                              <TableCell sx={{background: 'lightgray',fontWeight: 'bold'}}>Time<br />时间</TableCell>
                              <TableCell sx={{background: 'lightgray',fontWeight: 'bold'}}>Location<br />地点</TableCell>
                              <TableCell sx={{background: 'lightgray',fontWeight: 'bold'}}>Capacity<br />容量</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            <TableRow>
                              <TableCell>
                                <Link href={`/documents/ac_classes_math.pdf`} color="primary" underline="none" target="_blank">
                                  Beast Academy 1/2 
                                </Link>
                                </TableCell>
                              <TableCell>

                              </TableCell>                                
                              <TableCell>Mr. Mark Jacob</TableCell>
                              <TableCell>Sat 11:10 -12:00 pm</TableCell>
                              <TableCell>1202</TableCell>
                              <TableCell>15</TableCell>
                            </TableRow>
                             <TableRow>
                              <TableCell>
                                <Link href={`/documents/ac_classes_math.pdf`} color="primary" underline="none" target="_blank">
                                  Beast Academy 3/4 
                                </Link>
                                </TableCell>
                              <TableCell>
                                <Link href={`/documents/ac_syllabus_Beast_Acacemy_3_4.pdf`} color="primary" underline="none" target="_blank">
                                  Syllabus (PDF) 
                                </Link>
                              </TableCell>

                              <TableCell>Mr. Thomas Schlauch</TableCell>
                              <TableCell>Sat 11:10 -12:00 pm</TableCell>
                              <TableCell>1204</TableCell>
                              <TableCell>15</TableCell>
                            </TableRow>

                            <TableRow>
                              <TableCell>
                                <Link href={`/documents/ac_classes_math.pdf`} color="primary" underline="none" target="_blank">
                                  Prealgebra 
                                </Link>
                                </TableCell>
                              <TableCell>
                                <Link href={`/documents/ac_syllabus_pre_algebra.pdf`} color="primary" underline="none" target="_blank">
                                  Syllabus (PDF) 
                                </Link>
                              </TableCell>                                
                              <TableCell>Ms. Brenda Xiao</TableCell>
                              <TableCell>Sat 11:10 -12:00 pm</TableCell>
                              <TableCell>1212</TableCell>
                              <TableCell>15</TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell>
                                <Link href={`/documents/ac_classes_math.pdf`} color="primary" underline="none" target="_blank">
                                  Algebra 
                                </Link>
                                </TableCell>
                              <TableCell>
                                <Link href={`/documents/ac_syllabus_algebra.pdf`} color="primary" underline="none" target="_blank">
                                  Syllabus (PDF) 
                                </Link>
                              </TableCell>                                  
                              <TableCell>Ms. Brenda Xiao</TableCell>
                              <TableCell>Tentative Sat 7-9 pm</TableCell>
                              <TableCell>Online</TableCell>
                              <TableCell>15</TableCell>
                            </TableRow>                            
                            <TableRow>
                              <TableCell>
                                <Link href={`/documents/ac_classes_sat.pdf`} color="primary" underline="none" target="_blank">
                                  SAT-Math 
                                </Link>
                                </TableCell>
                              <TableCell>
                                <Link href={`/documents/ac_syllabus_sat_math.pdf`} color="primary" underline="none" target="_blank">
                                  Syllabus (PDF) 
                                </Link>
                              </TableCell> 
                              <TableCell>Ms. Ellen Rose</TableCell>
                              <TableCell>Sat 7:00-8:50 pm</TableCell>
                              <TableCell>online</TableCell>
                              <TableCell>15</TableCell>
                            </TableRow>

                            <TableRow>
                              <TableCell>
                                <Link href={`/documents/ac_classes_chess.pdf`} color="primary" underline="none" target="_blank">
                                  Chess1 （初级班） 
                                </Link>
                                </TableCell>
                              <TableCell>
                              </TableCell> 
                              <TableCell>Mr. Tony Zheng</TableCell>
                              <TableCell>Sat 11:10 -12:00 pm</TableCell>
                              <TableCell>1207</TableCell>
                              <TableCell>10</TableCell>
                            </TableRow>

                            <TableRow>
                              <TableCell>
                                <Link href={`/documents/ac_classes_chess.pdf`} color="primary" underline="none" target="_blank">
                                  Chess2 （中级班） 
                                </Link>
                                </TableCell>
                              <TableCell>
                              </TableCell>                                 
                              <TableCell>Ms. Grace Yang</TableCell>
                              <TableCell>Sat 11:10 -12:00 pm</TableCell>
                              <TableCell>1205</TableCell>
                              <TableCell>10</TableCell>
                            </TableRow>

                            <TableRow>
                              <TableCell>
                                <Link href={`/documents/ac_classes_chess.pdf`} color="primary" underline="none" target>
                                  Chess3 （高级班） 
                                </Link>
                                </TableCell>
                              <TableCell>
                              </TableCell>                                 
                              <TableCell>Ms. Vivian Zhang</TableCell>
                              <TableCell>Sat 11:10 -12:00 pm</TableCell>
                              <TableCell>1235</TableCell>
                              <TableCell>10</TableCell>
                            </TableRow>

                            <TableRow>
                              <TableCell>
                                <Link href={`/documents/ac_classes_stem.pdf`} color="primary" underline="none" target="_blank">
                                  NC Science Olympiad Div A 
                                </Link>
                                </TableCell>
                              <TableCell>
                              </TableCell>                                 
                              <TableCell>Mr. Mark Jacob</TableCell>
                              <TableCell>Sat 1:00 - 3:00 pm</TableCell>
                              <TableCell>Apex Senior Center</TableCell>
                              <TableCell>15 or 30</TableCell>
                            </TableRow>

                            <TableRow>
                              <TableCell>
                                <Link href={`/documents/ac_classes_stem.pdf`} color="primary" underline="none" target="_blank">
                                  Python (Computing Olympiad) 
                                </Link>
                                </TableCell>
                              <TableCell>
                              </TableCell>                                 
                              <TableCell>Mr. Victor Zhou</TableCell>
                              <TableCell>Mon 7:00-8:00 pm</TableCell>
                              <TableCell>online</TableCell>
                              <TableCell>10</TableCell>
                            </TableRow>

                            <TableRow>
                              <TableCell>
                                <Link href={`/documents/ac_classes_stem.pdf`} color="primary" underline="none" target="_blank">
                                  Robotics & Young Engineer 
                                </Link>
                                </TableCell>
                              <TableCell>
                                <Link href={`/documents/ac_syllabus_engineering.pdf`} color="primary" underline="none" target="_blank">
                                  Syllabus (PDF) 
                                </Link>
                              </TableCell>                                 
                              <TableCell>Mr. Yitian Yang</TableCell>
                              <TableCell>Sun 1-3 pm (in person) 7-8 pm (online)</TableCell>
                              <TableCell>Online or ACC</TableCell>
                              <TableCell>15</TableCell>
                            </TableRow>                          
                            <TableRow>
                              <TableCell>
                                <Link href={`/documents/ac_classes_cartoon.pdf`} color="primary" underline="none" target="_blank">
                                  Draw Cartoon (卡通画)
                                </Link>
                                </TableCell>
                              <TableCell>
                              </TableCell>                                 
                              <TableCell>Ms. Katrina Ni</TableCell>
                              <TableCell>Sat 11:10 -12:00 pm</TableCell>
                              <TableCell>1214</TableCell>
                              <TableCell>15</TableCell>
                            </TableRow>

                            <TableRow>
                              <TableCell>
                                <Link href={`/documents/ac_classes_pencil.pdf`} color="primary" underline="none" target="_blank">
                                  Draw Color Pencil （彩铅画） 
                                </Link>
                                </TableCell>
                              <TableCell>
                              </TableCell>                                 
                              <TableCell>Ms. Zhaojun Wang</TableCell>
                              <TableCell>Sat 11:10 -12:00 pm</TableCell>
                              <TableCell>1219</TableCell>
                              <TableCell>15</TableCell>
                            </TableRow>

                            <TableRow>
                              <TableCell>
                                <Link href={`/documents/ac_classes_sketching.pdf`} color="primary" underline="none" target="_blank">
                                  Draw Sketching （素描）
                                </Link>
                                </TableCell>
                              <TableCell>
                              </TableCell>                                 
                              <TableCell>Ms. Chunmei Tian</TableCell>
                              <TableCell>Sat 11:10 -12:00 pm</TableCell>
                              <TableCell>2205</TableCell>
                              <TableCell>15</TableCell>
                            </TableRow>

                            <TableRow>
                              <TableCell>
                                <Link href={`/documents/ac_classes_dance.pdf`} color="primary" underline="none">
                                  Dance_musical theater(Kids) 
                                </Link>
                                </TableCell>
                              <TableCell>
                              </TableCell>                                 
                              <TableCell>Ms. Di Zhu</TableCell>
                              <TableCell>Sat 11:10 -12:00 pm</TableCell>
                              <TableCell>Basement</TableCell>
                              <TableCell>20</TableCell>
                            </TableRow>

                            <TableRow>
                              <TableCell>
                                <Link href={`/documents/ac_classes_speech.pdf`} color="primary" underline="none">
                                  Youth Chinese Public Speaking & Performance<br /> (青少年中文口才表演综合班)
                                </Link>
                                </TableCell>
                              <TableCell>
                              </TableCell>                                 
                              <TableCell>Ms. Sherry Shi</TableCell>
                              <TableCell>Sat 11:10 -12:00 pm</TableCell>
                              <TableCell>TBD</TableCell>
                              <TableCell>15</TableCell>
                            </TableRow>

                            <TableRow>
                              <TableCell>
                                <Link href={`/documents/ac_classes_art.pdf`} color="primary" underline="none" target="_blank">
                                  Zumba (Adults)
                                </Link>
                                </TableCell>
                              <TableCell>
                              </TableCell>                                 
                              <TableCell>Ms. Di Zhu</TableCell>
                              <TableCell>Sat 9:30 - 10:30 am</TableCell>
                              <TableCell>Basement</TableCell>
                              <TableCell>20</TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell>
                                <Link href={`/documents/ac_classes_badminton.pdf`} color="primary" underline="none" target="_blank">
                                  Badminton K1 (Age 6-12)
                                </Link>
                                </TableCell>
                              <TableCell>
                              </TableCell>                                 
                              <TableCell>Coach T</TableCell>
                              <TableCell>Sat 1:00- 2:00 pm</TableCell>
                              <TableCell>Peak Sports</TableCell>
                              <TableCell>10</TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell>
                                <Link href={`/documents/ac_classes_badminton.pdf`} color="primary" underline="none" target="_blank">
                                  Badminton K2 (Age 12+)
                                </Link>
                                </TableCell>
                              <TableCell>
                              </TableCell>                                 
                              <TableCell>Coach T</TableCell>
                              <TableCell>Sat 2:00- 3:00 pm</TableCell>
                              <TableCell>Peak Sports</TableCell>
                              <TableCell>10</TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell>
                                <Link href={`/documents/ac_classes_badminton.pdf`} color="primary" underline="none" target="_blank">
                                  Badminton Adult
                                </Link>
                                </TableCell>
                              <TableCell>
                              </TableCell>                                 
                              <TableCell>Coach Jeff Wu</TableCell>
                              <TableCell>Sun 6:00-7:00 pm</TableCell>
                              <TableCell>Peak Sports</TableCell>
                              <TableCell>8</TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell>
                                <Link href={`/documents/ac_classes_basketball.pdf`} color="primary" underline="none" target="_blank">
                                  Basketball
                                </Link>
                                </TableCell>
                              <TableCell>
                              </TableCell>                                 
                              <TableCell>Coach Stephen Zhang</TableCell>
                              <TableCell>Sun 1:00-3:00 pm</TableCell>
                              <TableCell>SPORTHQ</TableCell>
                              <TableCell>26</TableCell>
                            </TableRow>

                            <TableRow>
                              <TableCell>
                                <Link href={`/documents/ac_classes_tabletennis.pdf`} color="primary" underline="none" target="_blank">
                                  Table Tennis (Age 5-15)
                                </Link>
                                </TableCell>
                              <TableCell>
                              </TableCell>                                 
                              <TableCell>Coach Di Yu</TableCell>
                              <TableCell>Sun 3:00-4:00 pm pm or Tues 7:10-8:10pm</TableCell>
                              <TableCell>CITTA</TableCell>
                              <TableCell>12</TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell>
                                <Link href={`/documents/ac_classes_soccer.pdf`} color="primary" underline="none" target="_blank">
                                  Soccer (Kids)
                                </Link>
                                </TableCell>
                              <TableCell>
                              </TableCell>                                 
                              <TableCell>Coach Fan, Liu</TableCell>
                              <TableCell>Sunday 10:00-11:30 am</TableCell>
                              <TableCell>Davis Drive Park</TableCell>
                              <TableCell>30</TableCell>
                            </TableRow>

                          </TableBody>
                        </Table>
                      </TableContainer>

                    </Box>

                    <Box textAlign={'left'} sx={{ mt: 2 }}>
                      <Typography>
                                    ACC: Apex Community Center (53 Hunter St, Apex, NC 27502)<br />
                                    Apex Senior Center: 63 Hunter Street, Apex, NC 27502<br />
                                    Peak Sports: 2900 Perimeter Park Dr #200, Morrisville, NC 27560<br />
                                    SPORTHQ: 107 Edinburgh S Dr # 100A, Cary, NC 27518<br />
                                    CITTA: 2172 N Salem St., Ste 001, Apex, NC 27523<br />
                                    Davis Drive Park: 1610 Davis Dr, Apex, NC 27523
                      </Typography>
                    </Box>
                  </CardContent>
                  </Card>

              </Grid> 

              <Grid item xs={2} />
        </Grid>
      
      </div>

     <Box sx={{ height: '80px' }}></Box>
    </>
  )
}

export default ActivityClass